export default {
  textCardLogged: (
    <>
      Use this scientific illustration <br /> along with 75,000+ other options. <br /> Create
      beautiful Science <br /> designs in minutes with <br /> high-quality images, drawings, and
      icons.
    </>
  ),
  startCreatingNow: 'Start Creating Now',
  loginForm: {
    login: 'Log in to your account',
    joinUs: 'Join us for free',
  },
  registerFooter: {
    member: 'Already a member?',
    login: 'Do Login instead',
  },
  initDescription: 'The',
  description:
    'icon is the perfect fit for your brilliant infographic template. Build beautiful scientific, academic and educational infographics and presentations with this illustration, picture or drawing.',
  customizeInit: 'Customize the',
  customizeDescription:
    'illustration or drawing as needed, if needed and download, present or share your work instantly. This template was made by scientists, for scientists.',
  titleComplement: 'Illustration and Icon',
};
